
  import notifications from '~/mixins/pages/mission-control/notifications'
  export default {
    name: 'DropdownMessageComponent',
    mixins: [notifications],
    computed: {}
  }
